import Sidebar from './sidebar';

export function render() {
	Sidebar.render('.js-bs-sidebar');
}
